import type { BrandAppHomeDressing } from './brandAppContract'
import { contrastRatio, deriveInk, deriveSurface, pillInk } from './brandAppColor'

export type DressingSource = 'override' | 'derived' | 'non-overridable'

export interface DressingSurfaceValue {
  value: string
  source: DressingSource
}

export interface DressingTextValue extends DressingSurfaceValue {
  contrast: number
}

export interface BrandAppHomeDressingResult {
  sectionSurface: DressingSurfaceValue
  sectionTextColor: DressingTextValue
  homeTextColor: DressingTextValue
  navPillColor: DressingSurfaceValue
  navPillTextColor: DressingTextValue
  navPillActiveColor: DressingSurfaceValue
  navPillActiveTextColor: DressingTextValue
}

export const deriveHomeDressing = (
  primary: string,
  overrides: BrandAppHomeDressing = {}
): BrandAppHomeDressingResult => {
  const sectionSurfaceValue = overrides.sectionSurface ?? deriveSurface(primary, 1)
  const surface2 = deriveSurface(primary, 2)
  const sectionTextValue = deriveInk(sectionSurfaceValue, primary)
  const homeTextValue = overrides.homeTextColor ?? deriveInk(primary, primary)
  const navPillValue = overrides.navPillColor ?? surface2
  const navPillTextValue = overrides.navPillTextColor ?? pillInk(navPillValue, primary)
  const navPillActiveValue = overrides.navPillActiveColor ?? homeTextValue
  const navPillActiveTextValue = overrides.navPillActiveTextColor ?? pillInk(navPillActiveValue, primary)

  return {
    sectionSurface: {
      value: sectionSurfaceValue,
      source: overrides.sectionSurface ? 'override' : 'derived'
    },
    sectionTextColor: {
      value: sectionTextValue,
      source: 'non-overridable',
      contrast: contrastRatio(sectionSurfaceValue, sectionTextValue)
    },
    homeTextColor: {
      value: homeTextValue,
      source: overrides.homeTextColor ? 'override' : 'derived',
      contrast: contrastRatio(primary, homeTextValue)
    },
    navPillColor: {
      value: navPillValue,
      source: overrides.navPillColor ? 'override' : 'derived'
    },
    navPillTextColor: {
      value: navPillTextValue,
      source: overrides.navPillTextColor ? 'override' : 'derived',
      contrast: contrastRatio(navPillValue, navPillTextValue)
    },
    navPillActiveColor: {
      value: navPillActiveValue,
      source: overrides.navPillActiveColor ? 'override' : 'derived'
    },
    navPillActiveTextColor: {
      value: navPillActiveTextValue,
      source: overrides.navPillActiveTextColor ? 'override' : 'derived',
      contrast: contrastRatio(navPillActiveValue, navPillActiveTextValue)
    }
  }
}
